import React from 'react';
import authorityCategoryIcon from '../assets/images/authority_category_icon.png';
import damageCategoryIcon from '../assets/images/damage_category_icon.png';
import depreciationCategoryIcon from '../assets/images/depreciation_category_icon.png';
import panelCategoryIcon from '../assets/images/panel_category_icon.png';
import damageDepreciationCategoryIcon from '../assets/images/damage_depreciation_category_icon.png';
import './CategorySelection.css';

const categories = [
  { id: 'depreciation', name: 'Değer Kaybı', icon: depreciationCategoryIcon },
  {
    id: 'objection_to_authority_report',
    name: 'Bilirkişi Raporuna İtiraz',
    icon: authorityCategoryIcon,
  },
  { id: 'damage', name: 'Maddi Hasar', icon: damageCategoryIcon },
  { id: 'damage_depreciation', name: 'Maddi Hasar ve Değer Kaybı', icon: damageDepreciationCategoryIcon },
  { id: 'panel', name: 'Kontrol Paneli', icon: panelCategoryIcon },
];

export default function CategorySelection({ onSelect }) {
  const handleSelect = (cat) => {
    if (typeof onSelect === 'function') {
      onSelect(cat);
    }
  };

  return (
    <div className="category-selection-container">
      {categories.map((cat) => (
        <div
          key={cat.id}
          className="category-card"
          onClick={() => handleSelect(cat)}
        >
          <img src={cat.icon} alt={cat.name} className="category-icon" />
          <span className="category-name">{cat.name}</span>
        </div>
      ))}
    </div>
  );
}
